<template>
  <div class="dashboard-editor-container">
    <!-- <github-corner style="position: absolute; top: 0px; border: 0; right: 0;"/> -->

    <div class="info-container">
      <span class="display_name">欢迎,administrator</span>
      <div class="pageFormContent">
        <h2>信息统计</h2>
        <div class="main">
          <div class="section">
            <ul class="clearfix">
              <li>
                <span>当前在线用户数：</span>
                <i></i>
                <em>人</em>
              </li>
              <li>
                <span>当前在线用户数：</span>
                <i></i>
                <em>人</em>
              </li>
              <li>
                <span>当前在线用户数：</span>
                <i></i>
                <em>人</em>
              </li>
              <li>
                <span>当前在线用户数：</span>
                <i></i>
                <em>人</em>
              </li>
              <li>
                <span>当前在线用户数：</span>
                <i></i>
                <em>人</em>
              </li>
              <li>
                <span>当前在线用户数：</span>
                <i></i>
                <em>人</em>
              </li>
              <li>
                <span>当前在线用户数：</span>
                <i></i>
                <em>人</em>
              </li>
              <li>
                <span>当前在线用户数：</span>
                <i></i>
                <em>人</em>
              </li>
            </ul>
          </div>
          <div class="section">
            <h2>待办事项</h2>
            <ul class="clearfix">
              <li>
                <span>当前在线用户数：</span>
                <i></i>
                <em>人</em>
              </li>
              <li>
                <span>当前在线用户数：</span>
                <i></i>
                <em>人</em>
              </li>
              <li>
                <span>当前在线用户数：</span>
                <i></i>
                <em>人</em>
              </li>
              <li>
                <span>当前在线用户数：</span>
                <i></i>
                <em>人</em>
              </li>
              <li>
                <span>当前在线用户数：</span>
                <i></i>
                <em>人</em>
              </li>
              <li>
                <span>当前在线用户数：</span>
                <i></i>
                <em>人</em>
              </li>
              <li>
                <span>当前在线用户数：</span>
                <i></i>
                <em>人</em>
              </li>
              <li>
                <span>当前在线用户数：</span>
                <i></i>
                <em>人</em>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- <div>
      <img :src="emptyGif" class="emptyGif">
    </div>-->
  </div>
</template>

<script>
// import { mapGetters } from 'vuex'
// import GithubCorner from '@/components/GithubCorner'

export default {
  name: "Stores",
  components: {
    // GithubCorner
  },
  data() {
    return {
      // emptyGif: 'https://wpimg.wallstcn.com/0e03b7da-db9e-4819-ba10-9016ddfdaed3'
    };
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.emptyGif {
  display: block;
  width: 45%;
  margin: 0 auto;
}

.dashboard-editor-container {
  background-color: #fff;
  height: 100%;
  padding: 10px 30px;
  .info-container {
    position: relative;
    .display_name {
      font-size: 20px;
      line-height: 48px;
      color: #212121;
    }
    .pageFormContent {
      .main {
        .section {
          border-bottom: 1px solid #ededed;
          ul {
            padding-bottom: 30px;
            li {
              float: left;
              width: 50%;
              margin-bottom: 20px;
              span {
                float: left;
                width: 120px;
                padding: 0 5px;
                line-height: 40px;
                color: #666666;
                text-align: right;
                font-size: 12px;
              }
              i {
                display: block;
                line-height: 40px;
                height: 40px;
                width: 50%;
                float: left;
                border: 1px solid #ccc;
                font-size: 18px;
              }
              em {
                display: block;
                float: left;
                width: 5%;
                color: #666;
                text-align: center;
                line-height: 40px;
                font-size: 14px;
              }
            }
          }
          &:last-child {
            border-bottom: none;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/liveBroadcast/index.vue